import isEmpty from "is-empty";
import moment from "moment";
import React, { useEffect, useState, Suspense } from "react";

import { Col, Form, Row, Button, Table } from "react-bootstrap";
import { ConfirmModal } from "../Components/Modal/ConfirmModal";
import { CustomModal } from "../Components/Modal/CustomModal";
import { ToastMessage } from "../Components/Toast";

import {
  createMasterEvent,
  getDefaultMaxMin,
  getDefaultMaxMinHAC,
  setDefaultMaxMin,
  validateMasterEventsHAC,
} from "./Service";

import { useHistory } from "react-router";
import DatePicker from "react-datepicker";
import { useUser } from "../Context/UserProvider";

export default function HorseRacingAddSeries() {
  let history = useHistory();
  const { userData } = useUser();
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [defaultData, setDefaultData] = useState({
    enabled: true,
    betLock: true,
  });
  const [startDate, setStartDate] = useState(new Date());
  const [error, setError] = useState("");
  const [isValidate, setIsValidate] = useState(true);
  const [selectedCompetitionsName, setSelectedCompetitionsName] = useState("");
  const [
    showConfrimAlreadyCompetitionModal,
    setShowConfrimAlreadyCompetitionModal,
  ] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleCloseConfirmAlreadyCompetitionModal = () =>
    setShowConfrimAlreadyCompetitionModal(false);
  const handleOpenConfirmAlreadyCompetitionModal = () =>
    setShowConfrimAlreadyCompetitionModal(true);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setDefaultData((prev) => {
      if (name === "minStack") {
        if (value > prev?.maxStack) {
          setErrorMessage("Min Stack can not be greater than max stack");
        } else {
          setErrorMessage("");
        }
      }
      if (name === "maxStack") {
        if (prev?.minStack > value) {
          setErrorMessage("Min Stack can not be greater than max stack");
        } else {
          setErrorMessage("");
        }
      }
      return { ...prev, [name]: value };
    });
    setError("");
  };

  const handleSwitchChange = (e, type) => {
    setDefaultData((prev) => ({ ...prev, [type]: e.target.checked }));
    setError("");
  };

  const handleCloseToast = () => setShowToast(false);
  const handleShowToast = () => setShowToast(true);

  const getDefaultMaxMinHandler = async () => {
    const res = await getDefaultMaxMinHAC();
    if (res.code === 200) {
      const { max, min } = res.response;
      setDefaultData((prev) => ({ ...prev, maxStack: max, minStack: min }));
    }
    console.log(res, "resData");
  };

  const onSubmitHandler = async () => {
    const {
      maxStack,
      minStack,
      competitionsName,

      betLock,
      enabled,
    } = defaultData;

    const payload = {
      competitionsName,
      createdBy: userData.username,
      maxStack,
      minStack,
      startDate: moment(startDate).format("DD/MMM/YYYY 00:00:00") + " AM",
      betLock: !betLock,
      enabled,
    };

    const res = await createMasterEvent(payload);
    console.log(res, "resData");
    if (res.code === 200) {
      history.push(
        `/dashboard/horse-racing/competition-detail/${competitionsName}/${res.response.id}`
      );
    }
    // handleShowToast();
    // setToastMessage("Value updated successfully");
    // const eventID = "32432";
    // history.push(`/dashboard/horse-racing/add-event/${eventID}`);

    // console.log(res, "resData");
  };

  useEffect(() => {
    getDefaultMaxMinHandler();
  }, []);

  const validateMasterEventsHACHandler = async (e) => {
    const { value } = e.target;

    const res = await validateMasterEventsHAC(value);
    if (res.code === 200) {
      if (res.response.available) {
        handleOpenConfirmAlreadyCompetitionModal();
        setSelectedCompetitionsName(value);
      } else {
        setIsValidate(false);
      }
    }

    console.log(res, "resData");
  };

  const onConfirmHandler = () => {
    history.push(
      `/dashboard/horse-racing/competition-detail/${selectedCompetitionsName}`
    );
  };

  return (
    <>
      {/* <header class="mb-3">
          <div className="d-grid gap-2">
            <Button 
              variant="primary"
              >
              Add Series
            </Button>
           
          </div>
        </header> */}

      <div class="page-content">
        <div class="row" id="basic-table">
          <div class="col-12 p-0">
            <div
              class="card mb-0"
              style={{ backgroundColor: "transparent", border: "0" }}
            >
              <div class="card-content">
                <div class="card-body">
                  <div className="event_body series_value_set">
                    <Row>
                      <Col md={12}>
                        <Form>
                          <Form.Group className="mb-3" controlId="">
                            <Form.Label>Competition Name</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter competition name"
                              name="competitionsName"
                              value={defaultData?.competitionsName}
                              onChange={handleChange}
                              onBlur={validateMasterEventsHACHandler}
                            />
                          </Form.Group>

                          <Form.Group
                            className="mb-3"
                            controlId="formBasicPassword"
                          >
                            <Form.Label>Min Stack</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter min stack value"
                              name="minStack"
                              value={defaultData?.minStack}
                              onChange={handleChange}
                            />
                          </Form.Group>
                          <Form.Group
                            className="mb-3"
                            controlId="formBasicEmail"
                          >
                            <Form.Label>Max Stack</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter max stack value"
                              name="maxStack"
                              value={defaultData?.maxStack}
                              onChange={handleChange}
                            />
                          </Form.Group>

                          <Form.Group className="mb-3">
                            <Form.Label>Start Date</Form.Label>
                            <DatePicker
                              selected={startDate}
                              onChange={(date) => setStartDate(date)}
                            />
                          </Form.Group>

                          <Form.Check
                            type="switch"
                            id="betLock"
                            label={
                              defaultData?.betLock
                                ? "Bet Unlocked"
                                : "Bet Locked "
                            }
                            onChange={(e) => handleSwitchChange(e, "betLock")}
                            checked={defaultData?.betLock}
                          />

                          <Form.Check
                            type="switch"
                            id="enable"
                            label={defaultData?.enabled ? "Enable " : "Disable"}
                            onChange={(e) => handleSwitchChange(e, "enabled")}
                            checked={defaultData?.enabled}
                          />

                          {error && <p className="text-danger">{error}</p>}

                          {errorMessage && (
                            <p className="text-danger">{errorMessage}</p>
                          )}

                          <Button
                            variant="primary"
                            onClick={onSubmitHandler}
                            className="mt-3 w-100"
                            disabled={isValidate || errorMessage}
                          >
                            Save
                          </Button>
                        </Form>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastMessage
        show={showToast}
        close={handleCloseToast}
        message={toastMessage}
        type="Success"
        title=""
      />
      <ConfirmModal
        show={showConfrimAlreadyCompetitionModal}
        handleClose={handleCloseConfirmAlreadyCompetitionModal}
        handleConfirm={onConfirmHandler}
      >
        <h5>
          {selectedCompetitionsName} already exists, do you want to open it ?
        </h5>
      </ConfirmModal>
    </>
  );
}
